import { FulfillmentRateQuotesModel } from "@/apidtos";
import { useApi } from "@core/api";
import { registerExtension } from "@core/components/PipelineComponents/ExtensionProvider";
import { Badge } from "@core/components/ui/badge";
import { useQuery } from "@tanstack/react-query";
import _ from "lodash";

interface IMedicalShipToInformationProps {
  fulfillment: FulfillmentRateQuotesModel;
}

const MedicalShipToInformation: React.FC<IMedicalShipToInformationProps> = ({ fulfillment }) => {
  const api = useApi();
  const patientQuery = useQuery({
    queryKey: ["patient", "salesItem", ...[(fulfillment.Items?.map(x => x.SalesItemId) ?? [])]],
    queryFn: async () => {
      if (!fulfillment.Items?.length) {
        return null;
      }
      const results = await Promise.all((fulfillment.Items.map(x => api.GetProviderPrescriptionSalesItemBySalesItemId(x.SalesItemId)) ?? []));
      return results;
    },
  })
  if (!fulfillment.Items?.length) {
    return null;
  }
  const type = _.first(fulfillment.Items)!.SalesItem.Tags?.find((tag) => tag.Key === "ShippingOption")?.Value;
  if (!type) {
    return null;
  }
  if (patientQuery.isLoading || !patientQuery.data) {
    return null;
  }
  return (
    <span>
      <span className="space-x-2 float-end">
        <Badge variant="outline">{type}</Badge>
        {patientQuery.data.map((patient, index) => (
          <Badge variant="outline"
            key={`shippingratesextension_${patient.PrescriptionPatientName}_${index}`}>
              {patient.PrescriptionPatientName}
            </Badge>
        ))}
      </span>
    </span>
  );
};

registerExtension("_site.checkout.shippingrates.route.fulfillmenttitle", MedicalShipToInformation, "MedicalShipToInformation");
